console.log('Example JavaScript file src/scripts/example.js, imported from src/index.js');